import $ from 'jquery';

function moveXdebug(){
  if ($('.debug-section').length > 0) {
    $('.xdebug-var-dump, .xdebug-error').each(function(){
      var clone = $(this).clone();
      $('.debug-section').append(clone);
      $(this).remove();
    });
    $('.debug-section').append('<div class="close" onclick="$(\'.debug-section\').hide()">x</div>');
  }
}

$(function(){
  moveXdebug();
})